import Vue from "vue";

Vue.filter("timeFormatter", function (value) {
  if (!value) return "";
  value = value.toString();
  return value.replace("T", " ").replace(".000+00:00", " ");
});
